// removed by extract-text-webpack-plugin
module.exports = {"Details":"src-components-Destination-CountryDetails----CountryDetails-module---Details---3jVyG","Details__Hide":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Hide---1EWL9","Details__Wrapper":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Wrapper---u61sA","Details__Box":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Box---1vgyb","Details__Box__Items":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Box__Items---32K0n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Destination/CountryDetails/CountryDetails.module.scss
// module id = 724
// module chunks = 116453730430729